import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

import type { Color } from '@atlassian/data-classification-level/types';

import { Status } from './Status.ts';

export const NO_CLASSIFICATION = 'NO_CLASSIFICATION';

export const NO_CLASSIFICATION_OPTION_ID = 'NO_CLASSIFICATION_OPTION';
export const NO_CLASSIFICATION_OPTION: {
	id: string;
	name: string;
	order: number;
	definition: string;
	color: Color;
	status: Status;
} = {
	id: NO_CLASSIFICATION_OPTION_ID,
	name: 'No default',
	order: 0,
	definition: 'Pages in this space aren’t classified by default.',
	color: 'NONE' as Color,
	status: Status.PUBLISHED,
};

export const noClassificationForContentMessages: {
	name: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	definition: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	name: {
		id: 'data-classification.no-classification.content-name',
		defaultMessage: 'No classification',
		description: 'Label used when content is explicitly shown as unclassified.',
	},
	definition: {
		id: 'data-classification.no-classification.content-definition',
		defaultMessage: 'Content is not classified.',
		description: 'Description used when content is explicitly shown as unclassified.',
	},
});

type FormatMessage = (descriptor: MessageDescriptor) => string;

const getDefaultMessage = (descriptor: MessageDescriptor): string =>
	typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : '';

export const getNoClassificationForContent = (
	formatMessage: FormatMessage,
): {
	id: string;
	name: string;
	order: number;
	definition: string;
	color: Color;
	status: Status;
} => ({
	id: NO_CLASSIFICATION_OPTION_ID,
	name: formatMessage(noClassificationForContentMessages.name),
	order: 0,
	definition: formatMessage(noClassificationForContentMessages.definition),
	color: 'GREY' as Color,
	status: Status.PUBLISHED,
});

export const NO_CLASSIFICATION_FOR_CONTENT: {
	id: string;
	name: string;
	order: number;
	definition: string;
	color: Color;
	status: Status;
} = getNoClassificationForContent(getDefaultMessage);
